<template>
    <div v-if="!isMobile">
        <div class="games-menu">
            <div class="gamesm-item" v-for="outright in outrights" :key="outright.offerId" :class="{'is-selected': (outrightsselected && outrightsselected.offerId == outright.offerId)}">
                <div class="gamesm-item-content" v-on:click.stop="selectOutright({
                                outrightId: outright.outrightsOfferId,
                                eventType: 'outrights',
                                push: true
                                })">
                    <div class="gamesm-content-left">
                        <div class="gamesm-text">{{outright.name | offerlang}} ({{outright.betGroups.length}})</div>
                    </div>
                    <div class="gamesm-content-right">
                        <span class="gamesm-arrow" :class="{'is-selected': (outrightsselected && outrightsselected.offerId == outright.offerId)}"></span>
                    </div>
                </div>
                <div v-if="outrightsselected && outrightsselected.groupsResults">
                    <template v-for="(groupsResult, g) in outrightsselected.groupsResults">
                        <div class="gamesm-category-box" v-if="outrightsselected.offerId == outright.offerId" :key="g" :class="(betgroupselected && betgroupselected.betGroupId == groupsResult.betGroupId) ? 'is-selected' : ''" v-on:click.stop="selectBetGroup(groupsResult)">
                            <div class="gamesm-category-content">
                                <div class="gamesm-content-left">
                                    <div class="gamesm-text small">{{groupsResult.name | offerlang}} ({{groupsResult.oddTypes.length}})</div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>

            <div class="gamesm-item outrights is-selected" v-if="outrights.length == 0">
                <div class="gamesm-item-content">
                    <div class="gamesm-content-left">
                        <div class="gamesm-text">{{$t('NOOUTRIGHTSAVAILABLEFORTHISDATE')}}</div>
                    </div>
                </div>
            </div>

            <!--**************** -->
        </div>
        <!--div class="games-menu-small" v-if="!expandedMenu">
            <div class="gamesm-item expand" @click="expandedMenu = !expandedMenu">
                <i class="icon-arrow-down"></i>
            </div>
            <div class="gamesm-item" v-for="outright in outrights">
                <span>{{outright.name | offerlang}}</span>
            </div>
        </div-->
    </div>
    <vue-scroll :settings="{wheelPropagation:true}" v-else class="offer-menu-box">
        <div class="offer-menu sport">
            <div class="offer-menu-item" v-on:click="toggleGamesMenu">
                <div class="sportsicon-calendar"></div>
                <div class="gamesm-text">{{ $t('CALENDAR') }}</div>
            </div>
            <div class="offer-menu-item" v-on:click="leaguesFilter = !leaguesFilter;">
                <i class="sportsicon-leagues"></i>
                <div class="gamesm-text">{{ $t('LEAGUES') }}</div>
            </div>
            <div class="offer-menu-item" v-for="outright in outrights" :key="outright.offerId" v-on:click="selectOutright({
                                outrightId: outright.outrightsOfferId,
                                eventType: 'outrights',
                                push: true
                                }); leaguesFilter = false;" :class="{'is-selected': (outrightsselected && outrightsselected.offerId == outright.offerId)}">
                <div class="gamesm-text">{{outright.name | offerlang}}</div>
            </div>
        </div>
        <!-- leagues filter -->
        <div class="games-menu" v-if="leaguesFilter" :class="{active:leaguesFilter}">
            <!-- sports item -->
            <div class="gamesm-item" v-for="outright in outrights" :key="outright.offerId" v-on:click="selectOutright({
                                outrightId: outright.outrightsOfferId,
                                eventType: 'outrights',
                                push: true
                                })" :class="{'is-selected': (outrightsselected && outrightsselected.offerId == outright.offerId)}">
                <div class="gamesm-item-content">
                    <div class="gamesm-content-left">
                        <div class="gamesm-text">{{outright.name | offerlang}} ({{outright.betGroups.length}})</div>
                    </div>
                    <div class="gamesm-content-right" v-on:click.stop="toggleSport(sport.sportId)">
                        <span class="gamesm-arrow" :class="{'is-selected': (outrightsselected && outrightsselected.offerId == outright.offerId)}"></span>
                    </div>
                </div>
                <div v-if="outrightsselected && outrightsselected.betGroups">
                    <template v-for="betGroup in outrightsselected.betGroups">
                        <div class="gamesm-category-box" :key="betGroup.betGroupId" v-if="outrightsselected.offerId == outright.offerId" :class="{'is-selected': (betgroupselected && betgroupselected.betGroupId == betGroup.betGroupId)}" v-on:click.stop="selectBetGroup(betGroup)">
                            <div class="gamesm-category-content">
                                <div class="gamesm-text small">{{betGroup.betGroupName | offerlang}} ({{betGroup.oddTypes.length}})</div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </vue-scroll>
</template>

<script>
import {
    mapActions,
    mapGetters,
} from 'vuex';

export default {
    name: 'OutrightsMenuResults',
    props: ['outrightsselected', 'outrights', 'betgroupselected'],
    data()
    {
        return {
            expandedMenu: true,
            leaguesFilter: false,
        };
    },
    computed: {
        ...mapGetters([
            'globals',
            'isMobile',
            'offerHandling',
        ]),
    },
    methods:
    {
        ...mapActions([
            'selectMatch',
            'selectOutright',
            'selectBetGroup',
        ]),
        toggleGamesMenu()
        {
            const me = this;

            me.$emit('togglegamesmenu');
        },
        selectOutright(outright)
        {
            const me = this;

            me.$emit('selectOutright', outright);
        },
        selectBetGroup(betGroup)
        {
            const me = this;
            me.leaguesFilter = false;

            me.$emit('selectBetGroup', betGroup);
        },
    },
};
</script>
